import { Injectable } from '@angular/core';
import { StorageService } from './storage-service.service';
import { COOKIES_VERSION } from '@ildes/views/policies/policies-version';
export const lastDateCookiesUpdate = new Date(COOKIES_VERSION);


@Injectable({
  providedIn: 'root'
})
export class CookiesConsentService {

  constructor(
    private storage: StorageService
  ) { }

    setCookiesConsentData = (types) => {
        const all = Object.values(types).every((value) => value);
        const cookiesConsentData =  { all, errors: types.errors, version: COOKIES_VERSION };

        this.storage.setItem('cookiesConsentData', cookiesConsentData, true);
    }

    cookiesAccepted = () => {
        const acceptedCookiesData = this.storage.getItem('cookiesConsentData') || {};

        return acceptedCookiesData?.errors && (lastDateCookiesUpdate.getTime() <= new Date(acceptedCookiesData?.version).getTime());
    }

    showCookiesDialog = () => {
        const acceptedCookiesData = this.storage.getItem('cookiesConsentData', true);
        if (!acceptedCookiesData?.value?.version) {
            return true;
        }

        return lastDateCookiesUpdate.getTime() > new Date(acceptedCookiesData.value?.version).getTime();
    }

    removeCookiesData() {
        this.storage.removeItem('cookiesConsentData', true);
    }

}
